export function areSomePropertiesDifferent<T1 extends {}, T2 extends {} = T1>(obj1: T1, obj2: T2, keysToCheck: (keyof (T1 & T2))[]) {
  return keysToCheck.some((key) => (obj1[key] !== obj2[key]));
}